import { Button } from "@/components/ui/button";

const EmptyState = ({ message, actionLabel, onAction }) => (
  <div className="empty-state py-16">
    <img
      src="https://static.prod-images.emergentagent.com/jobs/d79f4e12-49d2-4273-980e-fb3c434a8417/images/f2b7626d87726d30e16e60289a6d933c9009f9780fa28acc64676ce5fd3fda67.png"
      alt="Empty state"
      className="w-48 h-48 object-contain opacity-80"
    />
    <p className="font-handwritten text-2xl text-[#7C8068] mb-4">{message}</p>
    {actionLabel && onAction && (
      <Button
        onClick={onAction}
        className="bg-[#55624F] text-white hover:bg-[#424D3D]"
        data-testid="empty-state-action"
      >
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;
